import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DataService, DateService, HTTPService, HelperService } from 'app/services';
import { datetimeFormat } from 'app/constants/date-time-format';

interface TransferVehicleDTO {
  transferTo: string;
  transferFrom: string;
  transferHistory: any[];
  vehicleDetail: VehicleDetailDTO;
  currentCustomerId: string;
  previousCustomerId: string;
}
interface VehicleDetailDTO {
  VIN: string;
  name: string;
}
@Component({
  selector: 'app-transfer-vehicle-dialog',
  templateUrl: './transfer-vehicle-dialog.component.html',
  styleUrls: ['./transfer-vehicle-dialog.component.scss'],
})
export class TransferVehicleDialogComponent implements OnInit {
  data: any = {};
  customerId: any = '';
  isProcessing: boolean = false;
  transferVehicle: TransferVehicleDTO = {
    currentCustomerId: '',
    previousCustomerId: '',
    transferFrom: '',
    transferTo: '',
    transferHistory: [],
    vehicleDetail: {
      VIN: '',
      name: '',
    },
  };
  vehicleId: string = '';
  isMFConnected = false;
  constructor(public dConfig: DynamicDialogConfig, public ref: DynamicDialogRef, private httpService: HTTPService, private helperService: HelperService, public dateService: DateService) { }

  ngOnInit() {
    const { customerId, customerList, currentCustomer, isMFConnected } = this.dConfig.data;
    if (customerId) this.customerId = customerId;

    this.isMFConnected = isMFConnected;
    if (currentCustomer) {
      this.transferVehicle.transferTo = currentCustomer.name;
      this.transferVehicle.currentCustomerId = currentCustomer._id;
    }

    if (customerList && customerList.length > 0) {
      this.transferVehicle.transferFrom = customerList[customerList.length - 1].customerName;
      this.transferVehicle.previousCustomerId = customerList[customerList.length - 1].customerId;

      const { VIN, name, _id, transferHistory } = customerList && customerList[customerList.length - 1].vehicles[0];
      if (VIN || name) {
        this.transferVehicle.vehicleDetail.VIN = VIN;
        this.transferVehicle.vehicleDetail.name = name;
        this.vehicleId = _id;
        if (transferHistory && transferHistory.length > 0) transferHistory.map((history) => (history.vehicleTransferDate = this.dateService.formatDate(history.vehicleTransferDate, datetimeFormat.mmmdyyyy)));
        this.transferVehicle.transferHistory = transferHistory;
      }
    }
  }

  handleSubmit() {
    const payload = {
      currentCustomerId: this.transferVehicle.currentCustomerId,
      previousCustomerId: this.transferVehicle.previousCustomerId,
      currentCustomerName: this.transferVehicle.transferTo,
      previousCustomerName: this.transferVehicle.transferFrom,
      VIN: this.transferVehicle.vehicleDetail.VIN,
      vehicleId: this.vehicleId,
      isMFConnected: this.isMFConnected,
    };
    this.isProcessing = true;
    this.httpService
      .transferVehicles(payload)
      .then((res) => {
        this.isProcessing = false;
        this.helperService.showToaster('success', 'The vehicle has been successfully transferred');
        res = {
          ...res,
          ...payload
        }
        const data = { selectedVehicle: res, type: 'updateVehicle' };
        this.ref.close(data);
      })
      .catch((err) => {
        this.helperService.showToaster('error', err);
        this.isProcessing = false;
      });
  }

  closeModal() {
    this.ref.close({ type: 'close' });
  }
}
